<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Lx8JQB/tc-custom/9781250037961.jpg?1731554071434" alt="This image is the cover for the book Final Solution"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Final Solution
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This groundbreaking history of the Holocaust presents "a brilliant synthesis and interpretation of the greatest crime of the modern era…harrowing and extraordinary” (</b><i><b>The Times</b></i><b>, UK).</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Cesarani
      </h2>
      
      <p class="authorDescription body article"><B>DAVID CESARANI, OBE, </B>was Research Professor in History at Royal Holloway, University of London and the award-winning author of <I>Becoming Eichmann</I> and <I>Major Farran's Hat</I>. He was awarded the OBE for services to Holocaust Education and advising the British government on the establishment of Holocaust Memorial Day. He died in October 2015.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a7e25da2